import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {Route} from "../../models/route";
import {ArtworkCategory} from "../../models/artwork-category";
import {Artwork} from "../../models/artwork";

@Injectable({
    providedIn: 'root'
})
export class RouteService {

    public route: Route = null;
    public routes: Array<Route> = [];
    public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private http: HttpClient,
    ) {}

    getAllMyRoutes(projectId, databaseId) {
        return this.http.get(this.getPath(projectId, databaseId)).pipe(
            tap(data => this.routes = data['data']['routes'])
        )
    }

    postRoute(projectId, databaseId, route: Route) {
        return this.http.post(this.getPath(projectId, databaseId), route.getObj(true)).pipe(
            tap(
                data => {
                    this.route = new Route(data['data']['route']);
                    this.routes.push(this.route);
                    this.onChange.emit(true);
                }
            )
        );
    }

    getSingleRoute(projectId, databaseId, routeId) {
        return this.http.get(this.getPath(projectId, databaseId) + '/' + routeId).pipe(
            tap(
                data => {
                    this.route = new Route(data['data']['route']);

                    const index = this.routes.findIndex(m => m["_id"] === data['data']['route']['_id']);

                    if (index > -1)
                        this.routes[index] = this.route;
                    else
                        this.routes.push(this.route);

                    this.onChange.emit(true);
                }
            )
        );
    }

    patchRoute(projectId, databaseId, routeId, route: Route) {
        return this.http.patch(this.getPath(projectId, databaseId) + '/' + routeId, route.getObj(true)).pipe(
            tap(
                data => {
                    this.route = new Route(data['data']['route']);

                    const index = this.routes.findIndex(db => db["_id"] === routeId);

                    if (index > -1)
                        this.routes[index] = this.route;
                    else
                        this.routes.push(this.route);

                    this.onChange.emit(true);
                }
            )
        );
    }

    deleteRoute(projectId, databaseId, routeId) {
        return this.http.delete(this.getPath(projectId, databaseId) + '/' + routeId).pipe(
            tap(
                () => {
                    if (this.route && this.route._id === routeId)
                        this.route = null;

                    this.routes.splice(this.routes.findIndex(m => m["_id"] === routeId), 1);

                    this.onChange.emit(true);
                }
            )
        );
    }

    addArtwork(projectId: string, databaseId: string, routeId: string, artworkIds: string[]) {
        return this.patchArtwork(this.getPath(projectId, databaseId) + '/' + routeId + '/artworks', {artworkIds});

    }
    removeArtwork(projectId: string, databaseId: string, routeId: string, artworkId: string) {
        return this.patchArtwork(this.getPath(projectId, databaseId) + '/' + routeId + '/artworks/' + artworkId + '/remove');
    }

    private patchArtwork(url, payload = {}) {
        return this.http.patch(url, payload).pipe(
            tap(
                data => {
                    this.route = new Route(data['data']['route']);

                    const index = this.routes.findIndex(db => db["_id"] === this.route._id);

                    if (index > -1)
                        this.routes[index] = this.route;
                    else
                        this.routes.push(this.route);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    private getPath(projectId, databaseId) {
        return '/api/v1/projects/' + projectId + '/databases/' + databaseId + '/routes';
    }
}
